export class TitleIconScheduleModel{
  title: string = null;
  icon: string = null;
  isExpand: boolean = false;
}
